import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_dkldnd6ff4: FaireBrandEntity = {
  token: "b_dkldnd6ff4",
  type: "brand",
  name: "ANGIE",
  avatarUrl:
    "https://cdn.faire.com/fastly/d33929807596b0691c134698023047dc11d52864a8d550879b4208b26b9804c4.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/13c93048adcf51ceabce1bb0687fff53448eb2bc4ae51926a64afe6c1e898f3a.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/d33929807596b0691c134698023047dc11d52864a8d550879b4208b26b9804c4.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/13c93048adcf51ceabce1bb0687fff53448eb2bc4ae51926a64afe6c1e898f3a.jpeg",
  location: "tempe, AZ, USA",
  minimumOrderDollars: 139,
  rating: 4.7,
  reviewCount: 425,
  isInsider: true,
  description:
    "Angie is a collection of clothing and accessories inspired by a global lifestyle and deeply rooted in bohemian and vintage influences. Launched in the early 90's, Angie has grown into a brand that embodies a well-traveled, romantic spirit. Our designers search the world for incredible art to bring clothing to life. We are not afraid of color. We are not shy of embellishment. We are bold, poetic, and yet instantly wearable. Angie is truly the every girl brand. \n",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:23.321Z",
    importedBy: "entity-db-cli",
  },
};
